const generateId = () => {
    return Date.now().toString()
}

/** View / layer mode: overlay (edit) vs silhouette (export, detection). */
export const VIEW_MODES = {
    OVERLAY: 'overlay',
    SILHOUETTE: 'silhouette',
}

export const EditorConfig = {
    VIEW_MODES,
    VIEWPORT: {
        MIN_WIDTH: 320,
        MIN_HEIGHT: 240,
    },
    INTERACTION_MODES: {
        IDLE: 'idle',
        DRAG_NODE: 'drag_node',
        PAN: 'pan',
        MARQUEE: 'marquee',
        TRANSFORM: 'transform',
    },
    ZOOM: {
        DEFAULT_PERCENT: 32,
        MIN_PERCENT: 10,
        MAX_PERCENT: 400,
        STEP_PERCENT: 10,
        /** Scale factor per wheel step (zoom in/out). */
        WHEEL_SCALE_BY: 1.01,
    },
    KEYBOARD: {
        DELETE_KEY: 'Delete',
        UNDO_KEY: 'z',
        REDO_KEY: 'y',
        PAN_KEY_CODE: 'Space',
        PAN_CURSOR_ACTIVE: 'grab',
        PAN_CURSOR_INACTIVE: 'default',
    },
    DEFAULT_IMAGE_NODE: {
        type: 'image',
        geometry: {
            x: 0,
            y: 0,
            width: 100,
            height: 100,
            rotation: 0,
        },
        content: {
            src: 'https://s3-temp-behaviour-prod.s3-accelerate.amazonaws.com/preview-artworks/9ed6ad89-c67a-4a46-b72e-0384577f032d',
        },
        style: {},
    },
    DEFAULT_TEXT_NODE: {
        id: generateId(),
        type: 'text',
        geometry: {
            x: 500,
            y: 500,
            rotation: 0,
        },
        content: {
            text: 'Hello, world!',
        },
        style: {
            fontSize: 60,
        },
    },
}
